import React from 'react';

/**
 * Reusable empty state component for consistent UI
 */
const EmptyState = ({ children, className = '' }) => {
  return (
    <div className={`text-center py-3 text-stone-500 text-xs border rounded bg-stone-50 ${className}`}>
      {children}
    </div>
  );
};

export default EmptyState;
